import React from 'react'
import { Link } from 'react-router-dom'
import { Icon, Message } from 'semantic-ui-react'

import { capitalizeSentence } from '@cbgms/base/utils/helpers'
import { useTranslation } from 'react-i18next'

export interface IRejectionMessageProps {
  rejection: IRejectionMessage
  error?: boolean
  showMultiple?: boolean
  onLinkClick?: () => void
}

export interface IRejectionMessage {
  title: string
  description: string
  type: string
  link?: string
  button?: string
  isOtherShop?: boolean
  UUIDs?: string[]
}

export const RejectionMessage: React.FC<IRejectionMessageProps> = props => {
  const { t } = useTranslation()
  const { rejection, error, onLinkClick, showMultiple } = props

  const icon = error ? 'ban' : 'warning sign'

  return (
    <Message data-testid='rejection-message' negative={error} warning={!error} icon={!!icon}>
      <Icon name={icon} />
      <Message.Content>
        <Message.Header data-testid='rejection-message-header'>{capitalizeSentence(rejection.title)}</Message.Header>
        {rejection.description && <p>{rejection.description}</p>}
        {rejection.UUIDs &&
          rejection.link &&
          !rejection.isOtherShop &&
          showMultiple &&
          rejection.UUIDs.map((UUID, i) => (
            <Link data-testid='rejection-message-link' key={UUID} to={`${rejection.link}/${UUID}`} target='_blank' className='d-flex'>
              {rejection.button} {i + 1}
            </Link>
          ))}
        {(!rejection.UUIDs || !showMultiple) && !rejection.isOtherShop && rejection.link && (
          <Link data-testid='rejection-message-link' to={rejection.link} onClick={onLinkClick}>
            {rejection.button}
          </Link>
        )}
        {rejection.isOtherShop && <div>{t('DeleteFlow.IsOtherShop')}</div>}
      </Message.Content>
    </Message>
  )
}

export default React.memo(RejectionMessage)
